import React from "react";

interface V3TrustStatsProps {
  translate: (key: string) => string;
}

const V3TrustStats: React.FC<V3TrustStatsProps> = ({ translate }) => {
  const stats = [1, 2, 3, 4].map((i) => ({
    value: translate(`newUpsell.v3.trust.stat${i}.value`),
    title: translate(`newUpsell.v3.trust.stat${i}.title`),
    desc: translate(`newUpsell.v3.trust.stat${i}.desc`),
  }));

  return (
    <section className="upsell-v3__trust">
      <div className="upsell-v3__trust-inner">
        <div className="upsell-v3__eyebrow">
          {translate("newUpsell.v3.trust.eyebrow")}
        </div>
        <div className="upsell-v3__trust-headerRow">
          <h2 className="upsell-v3__trust-title">
            {translate("newUpsell.v3.trust.title")}
            <br />
            {translate("newUpsell.v3.trust.titleLine2")}{" "}
            {translate("newUpsell.v3.trust.titleLine3")}
          </h2>
          <div
            className="upsell-v3__trust-rating"
            dangerouslySetInnerHTML={{
              __html: translate("newUpsell.v3.trust.ratingHeader"),
            }}
          />
        </div>

        <div className="upsell-v3__trust-statsGrid">
          {stats.map((s) => (
            <div className="upsell-v3__trust-statCell" key={s.title}>
              <div className="upsell-v3__trust-statValue">{s.value}</div>
              <div className="upsell-v3__trust-statTitle">{s.title}</div>
              <div className="upsell-v3__trust-statDesc">{s.desc}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default V3TrustStats;
